var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"style":{"fill":"rgb(255, 255, 255)","paintOrder":"stroke","strokeWidth":"5px","stroke":"rgb(58, 88, 158)"},"cx":"15.229","cy":"15.232","rx":"12.668","ry":"12.7","key":0}),React.createElement("path",{"id":"facebook","d":"M 12.7 12.7 L 10.16 12.7 L 10.16 15.24 L 12.7 15.24 L 12.7 22.861 L 16.51 22.861 L 16.51 15.241 L 18.822 15.241 L 19.051 12.701 L 16.511 12.701 L 16.511 11.643 C 16.511 11.036 16.633 10.796 17.22 10.796 L 19.052 10.796 L 19.052 7.621 L 16 7.621 C 13.716 7.621 12.7 8.627 12.7 10.552 L 12.7 12.7 Z","style":{"fill":"rgb(58, 88, 158)"},"key":1})]);
}

Facebook.defaultProps = {"width":"30.483","height":"30.482","viewBox":"0 0 30.483 30.482"};

module.exports = Facebook;

Facebook.default = Facebook;
